import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd, RouterModule, RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';
import {GoogleMapLoaderService} from './talenlio-hireos/common/service/google-map-loader.service';
import {AnalyticsService} from './talenlio-hireos/common/service/analytics.service';
import {AppUpdateService} from './talenlio-hireos/common/service/app-update.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        RouterModule
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    title = 'Talenlio - HireOs';

    constructor(
        private googleMapLoaderService: GoogleMapLoaderService,
        private router: Router,
        private analyticsService: AnalyticsService,
        private appUpdateService: AppUpdateService
    ) {
    }

    ngOnInit(): void {
        this.loadGoogleMapsScript();
        this.setupAnalyticsTracking();
        this.appUpdateService.watchForNewRelease();
    }

    private setupAnalyticsTracking(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.analyticsService.capturePageView();
        });
    }

    private loadGoogleMapsScript(): void {
        if (!document.querySelector('script[src^="https://maps.googleapis.com"]')) {
            let script = document.createElement('script');
            script = this.googleMapLoaderService.getScriptWithAttributes(script);
            this.googleMapLoaderService.handleOnload(script);
            this.googleMapLoaderService.handleOnError(script);
            document.head.appendChild(script);
        }
    }
}
